module.exports = __webpack_public_path__ + "img/M300L.0b740dc1.png";